
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "8c9d9c32c65adf9c0c4ac8071f9c6dcf22e7722e",
  "nuxt": {
    "buildId": "d8fbb7a0-8002-43a0-acf1-ae2f16dfe97f"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
